import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { spaceOf } from "@/lib/spaces";
import { useSettings } from "@/context/SettingsContext";
import { overdueMinutes } from "@/lib/priority";

const MIN = 60 * 1000;

export const overdueSince = (it, minutes = 60) =>
  it.type === "reminder" && it.priority === "high" && overdueMinutes(it) * MIN >= minutes * MIN
    ? new Date(it.first_sent_at)
    : null;

const fmtFor = (since) => {
  const mins = Math.floor((Date.now() - since) / 60000);
  return mins >= 60 ? `${Math.floor(mins / 60)}h ${mins % 60}m` : `${mins}m`;
};

export const OverdueBanner = ({ items }) => {
  const minutes = useSettings()?.team?.reminders?.overdue_minutes || 60;
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(t);
  }, []);
  const overdue = items.map((it) => ({ it, since: overdueSince(it, minutes) })).filter((o) => o.since);
  if (!overdue.length) return null;

  return (
    <div className="mb-[0.8em] flex animate-pulse items-start gap-[0.7em] rounded-[0.7em] border border-red-500/60 bg-red-500/15 px-[1em] py-[0.6em] text-red-100" data-testid="wallboard-overdue-banner">
      <AlertTriangle className="mt-[0.15em] h-[1.2em] w-[1.2em] shrink-0 text-red-400" />
      <div className="min-w-0">
        <p className="text-[0.75em] font-bold uppercase tracking-[0.18em] text-red-300">Overdue · high priority not ticked off</p>
        <div className="mt-[0.2em] flex flex-wrap gap-x-[1.4em] gap-y-[0.2em]">
          {overdue.map(({ it, since }) => (
            <span key={it.key} className="font-semibold" data-testid={`overdue-item-${it.id}`}>
              {it.title} <span className="font-normal text-red-200/80">· {spaceOf(it.space).name} · emailing {fmtFor(since)}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
